module.exports = __webpack_public_path__ + "static/winged_boots-521672e4748525134bb8da8e2819db48.jpeg";